import { __rest } from 'tslib';
import React from 'react';
import ImageUploading from 'react-images-uploading';
import { styled } from '@mui/material/styles';
import { Image } from '@piiqtechnologies/svg-icons';
import { PeekStack } from './PeekStack.js';
import { PeekBox } from './PeekBox.js';
import { PeekTypography } from './PeekTypography.js';
import { PeekCircularProgress } from './PeekCircularProgress.js';

const StyledPeekBox = styled(PeekBox)(({ theme }) => ({
    border: `${theme.spacing(0.1)} dashed ${theme.palette.grey[300]}`,
    backgroundColor: theme.palette.grey[100],
    padding: theme.spacing(2.5),
}));
function CircularProgressWithLabel(props) {
    return (React.createElement(PeekBox, { sx: { position: "relative", display: "inline-flex" } },
        React.createElement(PeekCircularProgress, Object.assign({ variant: "determinate" }, props)),
        React.createElement(PeekBox, { sx: {
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: "absolute",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            } },
            React.createElement(PeekTypography, { variant: "body2", color: "secondary.main" }, `${Math.round(props.value)}%`))));
}
const PeekImageUpload = (_a) => {
    var { title, subTitle, description } = _a, props = __rest(_a, ["title", "subTitle", "description"]);
    return (React.createElement(ImageUploading, Object.assign({}, props), ({ imageList, onImageUpload, dragProps }) => (React.createElement(PeekStack, { spacing: 3, direction: "column" },
        React.createElement(StyledPeekBox, Object.assign({ onClick: onImageUpload }, dragProps),
            React.createElement(PeekStack, { alignItems: "center", direction: "column", spacing: 1 },
                React.createElement(Image, null),
                React.createElement(PeekStack, { alignItems: "center", direction: "column", spacing: 0.5 },
                    React.createElement(PeekTypography, { variant: "h4", fontWeight: "fontWeightBold" }, title),
                    React.createElement(PeekTypography, { variant: "h4", fontWeight: "fontWeightBold", color: "secondary" }, subTitle)),
                React.createElement(PeekTypography, { variant: "body2", color: "error.main" }, description))),
        !!(imageList === null || imageList === void 0 ? void 0 : imageList.length) && (React.createElement(StyledPeekBox, null,
            React.createElement(PeekStack, { direction: "row", alignItems: "baseline", spacing: 1 }, imageList.map((image, index) => {
                var _a;
                return (React.createElement(PeekBox, { key: index },
                    React.createElement(PeekStack, { alignItems: "center", direction: "column", spacing: 0.5 },
                        React.createElement(Image, null),
                        React.createElement(PeekTypography, { variant: "body2" }, (_a = image === null || image === void 0 ? void 0 : image.file) === null || _a === void 0 ? void 0 : _a.name),
                        !!(image === null || image === void 0 ? void 0 : image.uploadProgress) && (React.createElement(CircularProgressWithLabel, { value: image === null || image === void 0 ? void 0 : image.uploadProgress, color: "secondary", size: 40 })))));
            }))))))));
};

export { CircularProgressWithLabel, PeekImageUpload, PeekImageUpload as default };
